
import { defineComponent, PropType } from 'vue'
import { VulnerabilityOccurrence, VulnerabilitySeverity } from '~/types/types'

import { formatDate, parseISODate } from '~/utils/date'
import { severityLabelTypeMap } from '~/utils/dependencies'
import { getOrdinalSuffix } from '~/utils/string'

export default defineComponent({
  name: 'DependencyOccurenceInfoGroup',
  props: {
    occurrence: {
      type: Object as PropType<VulnerabilityOccurrence | null>,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    percentile(): string {
      if (!this.occurrence?.vulnerability.epssPercentile) return ''
      return `${getOrdinalSuffix(
        Math.round(this.occurrence.vulnerability.epssPercentile * 100)
      )} percentile`
    },

    introducedIn(): string {
      if (this.occurrence?.vulnerability.introducedVersions === undefined) return ''
      return this.occurrence.vulnerability.introducedVersions.join(', ')
    },

    fixedIn(): string {
      if (this.occurrence?.vulnerability.fixedVersions === undefined) return ''
      return this.occurrence.vulnerability.fixedVersions.join(', ')
    }
  },
  methods: {
    parseISODate,
    formatDate,
    severityLabelType(severityText: VulnerabilitySeverity | 'UNKNOWN'): string {
      return severityLabelTypeMap[severityText] || 'neutral'
    }
  }
})
